var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "import-panel"
  }, [_c('el-timeline', [_c('el-timeline-item', [_c('upload-section', {
    staticClass: "time-node",
    attrs: {
      "status": _vm.status,
      "need-confirm": _vm.needConfirm,
      "template-link": _vm.templateLink,
      "upload-name": _vm.uploadName,
      "plugins": _vm.plugins,
      "root": _vm.root,
      "accept": _vm.accept
    },
    on: {
      "status-change": _vm.handleStatus,
      "import": _vm.doImport
    }
  }), _c('template', {
    slot: "dot"
  }, [_c('div', {
    staticClass: "dot-item",
    style: _vm.dotStyleUpload
  }, [_vm._v("1")])])], 2), _c('el-timeline-item', [_c('import-section', {
    ref: "import",
    staticClass: "time-node",
    attrs: {
      "color": _vm.dotStyleImport.color,
      "status": _vm.status,
      "root": _vm.root,
      "plugins": _vm.plugins
    },
    on: {
      "status-change": _vm.handleStatus,
      "imported": _vm.handleImported
    }
  }), _c('template', {
    slot: "dot"
  }, [_c('div', {
    staticClass: "dot-item",
    style: _vm.dotStyleImport
  }, [_vm._v("2")])])], 2), _c('el-timeline-item', [_c('summary-section', {
    staticClass: "time-node",
    attrs: {
      "status": _vm.status,
      "result": _vm.result,
      "color": _vm.dotStyleComplete.color
    },
    on: {
      "status-change": _vm.handleStatus
    }
  }), _c('template', {
    slot: "dot"
  }, [_c('div', {
    staticClass: "dot-item",
    style: _vm.dotStyleComplete
  }, [_vm._v("3")])])], 2)], 1), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("关闭")])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };